export const load = () => ({
	h1: 'Preserve Historic Windows with Indow Inserts',
	title: 'Preserve Historic Windows with Indow Inserts',
	description:
		'Historic window preservation is conservation of resources and architectural history. Our inserts help preserve historic integrity and make the space more comfortable than before.',
	showTitle: true,
});
